module.exports = __webpack_public_path__ + "img/face-happy.df7a12fa.svg";